/* Cozie theme layer: product form, gallery, drawers, cart, sticky ATC. No dependencies. */
(() => {
  const S = window.CozieStrings || {};
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = window.CozieMoneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    const fmtNum = (n, d, ts = ',', ds = '.') => {
      const parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmtNum(cents, 0);
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2);
      }
    });
  }

  /* ---------- drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.classList.add('cz-locked');
    const panel = d.querySelector('.cz-drawer__panel');
    requestAnimationFrame(() => panel && panel.focus());
    return true;
  }
  function closeDrawer(d) {
    if (!d) return;
    d.hidden = true;
    if (!document.querySelector('.cz-drawer:not([hidden])')) document.documentElement.classList.remove('cz-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cz-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-cz-open'))) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-cz-close]');
    if (closer) closeDrawer(closer.closest('.cz-drawer'));
    const menuClose = e.target.closest('[data-cz-menu-close]');
    if (menuClose) menuClose.closest('details').open = false;
    document.querySelectorAll('details[data-cz-menu][open]').forEach((m) => { if (!m.querySelector('.cz-menu__panel').contains(e.target) && !m.querySelector('summary').contains(e.target)) m.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = [...document.querySelectorAll('.cz-drawer:not([hidden])')].pop();
    if (open) closeDrawer(open);
    document.querySelectorAll('details[data-cz-menu][open]').forEach((m) => (m.open = false));
  });
  // simple focus trap
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const open = [...document.querySelectorAll('.cz-drawer:not([hidden])')].pop();
    if (!open) return;
    const f = [...open.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  /* ---------- cart (drawer + /cart page share one render path) ---------- */
  const CART_SECTION = 'cozie-cart-drawer';
  function cartSections() {
    const ids = [CART_SECTION];
    document.querySelectorAll('[data-cz-cart-page]').forEach((el) => { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
    return ids;
  }
  function renderSections(sections) {
    if (!sections) return;
    const drawerHtml = sections[CART_SECTION];
    if (drawerHtml) {
      const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const fresh = doc.querySelector('[data-cz-cart-inner]');
      const cur = document.querySelector('[data-cz-cart-inner]');
      if (fresh && cur) {
        cur.replaceWith(fresh);
        const count = fresh.getAttribute('data-count');
        document.querySelectorAll('[data-cz-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === '0'; });
      }
    }
    document.querySelectorAll('[data-cz-cart-page]').forEach((page) => {
      const html = sections[page.dataset.sectionId];
      if (!html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cz-cart-page]');
      if (fresh) page.replaceWith(fresh);
    });
    tickTimers();
    enforceCap();
  }
  /* ---------- max 2 duvet sets per order (sleep mask etc. not limited) ---------- */
  const CAP_HANDLE = 'coziesleep-boho', CAP_MAX = 2, CAP_MSG = 'Max 2 duvet sets per order';
  let capBusy = false, capHit = false, capAgain = false;
  async function capCart() { return (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); }
  function capCount(cart) { return cart.items.filter((i) => i.handle === CAP_HANDLE).reduce((s, i) => s + i.quantity, 0); }
  async function enforceCap() {
    if (capBusy) { capAgain = true; return; } capBusy = true;
    try {
      const cart = await capCart();
      const lines = cart.items.filter((i) => i.handle === CAP_HANDLE);
      let total = capCount(cart);
      const qty = {}; lines.forEach((l) => (qty[l.key] = l.quantity));
      if (total > CAP_MAX) {
        let excess = total - CAP_MAX, last = null;
        for (const l of lines.slice().reverse()) {
          if (excess <= 0) break;
          const nq = Math.max(0, l.quantity - excess); excess -= l.quantity - nq; qty[l.key] = nq;
          last = await cartPost('cart/change.js', { id: l.key, quantity: nq });
        }
        total = CAP_MAX; capHit = true;
        if (last && last.sections) renderSections(last.sections);
      }
      applyCapUI(qty, total);
    } catch (_) { /* never block the cart */ } finally { capBusy = false; if (capAgain) { capAgain = false; enforceCap(); } }
  }
  function applyCapUI(qty, total) {
    const at = total >= CAP_MAX;
    document.querySelectorAll('[data-cz-change]').forEach((b) => {
      const k = b.getAttribute('data-cz-change');
      if (!(k in qty)) return;
      if ((parseInt(b.getAttribute('data-qty'), 10) || 0) > qty[k]) { b.disabled = at; if (at) b.title = CAP_MSG; else b.removeAttribute('title'); }
    });
    document.querySelectorAll('.cz-cap-note').forEach((n) => n.remove());
    if (!(capHit && at)) return;
    document.querySelectorAll('[data-cz-cart-inner] .cz-drawer__body, [data-cz-cart-page]').forEach((box) => {
      const n = document.createElement('p');
      n.className = 'cz-cap-note'; n.setAttribute('role', 'status'); n.textContent = CAP_MSG;
      n.style.cssText = 'margin:0 0 12px;padding:8px 12px;border-radius:10px;background:rgba(67,60,122,.08);color:#433c7a;font-size:13px;font-weight:600;text-align:center';
      box.prepend(n);
    });
  }
  function renderCart(html) { renderSections({ [CART_SECTION]: html }); }
  function setLoading(on) {
    document.querySelectorAll('[data-cz-cart], [data-cz-cart-page]').forEach((el) => el.classList.toggle('is-loading', on));
  }
  async function cartPost(path, payload) {
    const res = await fetch(root + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign(payload, { sections: cartSections(), sections_url: location.pathname }))
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
    return data;
  }
  async function changeLine(key, qty) {
    setLoading(true);
    try { renderSections((await cartPost('cart/change.js', { id: key, quantity: qty })).sections); }
    catch (_) { /* keep current cart */ }
    finally { setLoading(false); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cz-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.getAttribute('data-cz-change'), Math.max(0, parseInt(b.getAttribute('data-qty'), 10) || 0));
  });
  /* change colour/size of a line: add the new variant first, then remove the old line (nothing is lost if the add fails) */
  document.addEventListener('change', async (e) => {
    const sel = e.target.closest('[data-cz-line-opt]');
    if (!sel) return;
    const box = sel.closest('[data-cz-line-edit]');
    const err = box.querySelector('[data-cz-line-err]');
    let variants = [];
    try { variants = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (_) { return; }
    const chosen = Array.from(box.querySelectorAll('[data-cz-line-opt]')).map((s) => s.value);
    const v = variants.find((x) => x.o.every((o, i) => o === chosen[i]));
    if (err) err.hidden = true;
    if (!v || !v.a) { if (err) { err.textContent = S.unavailable || 'Unavailable'; err.hidden = false; } return; }
    const key = box.dataset.key, qty = parseInt(box.dataset.qty, 10) || 1;
    setLoading(true);
    try {
      await cartPost('cart/add.js', { items: [{ id: v.id, quantity: qty }] });
      renderSections((await cartPost('cart/change.js', { id: key, quantity: 0 })).sections);
    } catch (ex) {
      if (err && err.isConnected) { err.textContent = ex.message || S.error; err.hidden = false; }
    } finally { setLoading(false); }
  });
  /* order note (optional) */
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-cz-cart-note]');
    if (!t) return;
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: t.value }) });
  });
  /* upsell carousel arrows */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cz-carousel-step]');
    if (!b) return;
    const track = b.closest('[data-cz-carousel]').querySelector('[data-cz-carousel-track]');
    track.scrollBy({ left: track.clientWidth * Number(b.dataset.czCarouselStep), behavior: 'smooth' });
  });

  /* ---------- honest cart timer ----------
     dispatch: counts to today's real cutoff (HH:MM) in the configured time zone; after the cutoff / on a
               non-dispatch day it only says when the next dispatch is (no countdown).
     sale:     counts to a fixed end date/time and hides itself afterwards. Nothing ever loops or resets. */
  const WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const tzFmt = {};
  function zonedNow(tz, d) {
    try {
      tzFmt[tz] = tzFmt[tz] || new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short' });
      const o = {};
      tzFmt[tz].formatToParts(d).forEach((p) => { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second, wd: WD.indexOf(o.weekday) };
    } catch (_) { return null; }
  }
  function fmtLeft(sec) {
    const p = (n) => String(n).padStart(2, '0');
    const d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
    return d > 0 ? d + 'd ' + p(h) + 'h ' + p(m) + 'm' : p(h) + ':' + p(m) + ':' + p(s);
  }
  function timerText(el, tpl, token, val) {
    const t = el.querySelector('[data-cz-timer-text]');
    const parts = String(tpl || '').split(token);
    t.textContent = '';
    parts.forEach((part, i) => {
      t.append(part);
      if (i < parts.length - 1) { const b = document.createElement('b'); b.textContent = val; t.append(b); }
    });
  }
  /* When does an order placed now ship? ds: cutoff "HH:MM" (23:59 = end of day), sat/sun dispatch flags.
     lead = business days after the order day (0 = same day). Returns { ship (Date, UTC-midnight), label, left (s) }.
     left > 0 only if ordering before today's cutoff really ships earlier than ordering just after it. */
  function dispatchPlan(now, ds, lead) {
    const m = /^(\d{1,2}):(\d{2})$/.exec((ds.cutoff || '').trim());
    if (!m || +m[1] > 23 || +m[2] > 59) return null;
    const ships = (wd) => (wd === 6 ? ds.sat === 'true' : wd === 0 ? ds.sun === 'true' : true);
    if (![0, 1, 2, 3, 4, 5, 6].some(ships)) return null;
    let cut = (+m[1]) * 3600 + (+m[2]) * 60;
    if (cut === 86340) cut = 86400; // 23:59 = until midnight
    const cur = now.h * 3600 + now.mi * 60 + now.s;
    const today = Date.UTC(now.y, now.m - 1, now.d), DAY = 86400000;
    const shipFor = (orderDay) => {
      let d = orderDay;
      if (lead === 0) { while (!ships(new Date(d).getUTCDay())) d += DAY; return d; }
      for (let i = 0; i < lead; i++) { do d += DAY; while (!ships(new Date(d).getUTCDay())); }
      return d;
    };
    const before = cur < cut;
    const orderDay = before ? today : today + DAY;
    const ship = shipFor(orderDay), shipLater = shipFor(orderDay + DAY);
    const diff = Math.round((ship - today) / DAY);
    const label = diff === 0 ? 'today' : diff === 1 ? 'tomorrow' : DAY_NAMES[new Date(ship).getUTCDay()];
    return { ship: new Date(ship), label, left: before && ship !== shipLater ? cut - cur : 0 };
  }
  function tickTimer(el) {
    const ds = el.dataset, nowDate = new Date();
    const now = zonedNow(ds.tz || 'America/New_York', nowDate);
    if (!now) { el.hidden = true; return; }
    if (ds.mode === 'dispatch') {
      const plan = dispatchPlan(now, ds, parseInt(ds.lead, 10) || 0);
      if (!plan) { el.hidden = true; return; }
      if (plan.left > 0) {
        const tpl = String(ds.text || '');
        timerText(el, tpl.replace('[day]', plan.label), '[time]', fmtLeft(plan.left));
      } else {
        timerText(el, ds.textNext, '[day]', plan.label);
      }
      el.hidden = false;
    } else if (ds.mode === 'reserve') {
      if ((parseInt(ds.count, 10) || 0) < 1) { el.hidden = true; return; }
      let start = 0;
      try { start = parseInt(localStorage.getItem(RES_KEY), 10) || 0; if (!start) { start = Date.now(); localStorage.setItem(RES_KEY, String(start)); } } catch (_) { start = start || Date.now(); }
      const left = Math.ceil((start + (parseInt(ds.reserveMin, 10) || 10) * 60000 - Date.now()) / 1000);
      if (left > 0) {
        const p = (n) => String(n).padStart(2, '0');
        timerText(el, ds.text, '[time]', p(Math.floor(left / 60)) + ':' + p(left % 60));
      } else {
        const t = el.querySelector('[data-cz-timer-text]'); t.textContent = ds.textExpired || '';
        el.classList.add('is-expired');
      }
      el.hidden = false;
    } else if (ds.mode === 'sale') {
      const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})$/.exec((ds.end || '').trim());
      if (!m) { el.hidden = true; return; }
      const nowMs = Math.floor(nowDate.getTime() / 1000) * 1000;
      const offset = Date.UTC(now.y, now.m - 1, now.d, now.h, now.mi, now.s) - nowMs; // zone offset right now
      const endMs = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) - offset;
      const left = Math.floor((endMs - nowMs) / 1000);
      if (left <= 0) { el.hidden = true; return; }
      timerText(el, ds.text, '[time]', fmtLeft(left));
      el.hidden = false;
    } else { el.hidden = true; }
  }
  /* ship date for the product "Ships on" card: today (or the next dispatch day if past the cutoff / not a
     dispatch day) + N dispatch days, in the shop's time zone. Weekends skipped unless enabled in the cart timer settings. */
  function shipDates() {
    document.querySelectorAll('[data-cz-shipdate]').forEach((el) => {
      const ds = el.dataset, n = parseInt(ds.days, 10);
      const now = zonedNow(ds.tz || 'America/New_York', new Date());
      if (!now || isNaN(n) || n < 0) return;
      const plan = dispatchPlan(now, Object.assign({}, ds, { cutoff: ds.cutoff || '23:59' }), n);
      if (!plan) return;
      el.textContent = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(plan.ship);
    });
  }
  window.CozieShipDates = shipDates;
  shipDates();
  const RES_KEY = 'czCartReservedAt';
  function tickTimers() {
    // cart empty (real cart, no reservation timer shown) -> forget the reservation so a refilled cart starts fresh
    const inner = document.querySelector('[data-cz-cart-inner]');
    if (inner && inner.getAttribute('data-count') === '0' && !document.querySelector('[data-cz-timer][data-mode="reserve"]')) {
      try { localStorage.removeItem(RES_KEY); } catch (_) {}
    }
    document.querySelectorAll('[data-cz-timer]').forEach(tickTimer);
  }
  window.CozieTickTimers = tickTimers;
  tickTimers();
  setInterval(tickTimers, 1000);

  /* ---------- product form ---------- */
  class CzProductForm extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-cz-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.form = this.querySelector('form[data-cz-form]');
      this.idInput = this.querySelector('[data-cz-variant-id]');
      this.submit = this.querySelector('[data-cz-submit]');
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-cz-option-input]')) this.onOptionChange();
        if (e.target.matches('[data-cz-qty-radio]')) { this.syncSticky(); this.updatePicks(); }
        if (e.target.matches('[data-cz-pick]')) this.onPickChange(e.target);
      });
      this.addEventListener('click', (e) => {
        const step = e.target.closest('[data-cz-qty-step]');
        if (step) {
          const input = this.querySelector('.cz-qty__input');
          const mx = parseInt(input.max, 10) || 99;
          input.value = Math.min(mx, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.czQtyStep, 10)));
        }
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.updateAvailability();
      this.initPicks();
    }
    /* ---- v22: per-item pickers for bundle tiles 2/3 ---- */
    initPicks() {
      this.picks = this.querySelector('[data-cz-picks]');
      if (!this.picks || !this.variants.length) { this.picks = null; return; }
      try { this.pickNames = JSON.parse(this.picks.dataset.options || '[]'); } catch (_) { this.pickNames = []; }
      const sj = this.picks.querySelector('[data-cz-picks-swatches]');
      try { this.pickSw = sj ? JSON.parse(sj.textContent) : {}; } catch (_) { this.pickSw = {}; }
      const swn = (this.picks.dataset.swatchNames || '').toLowerCase().split(',').map((s) => s.trim());
      this.pickIsSwatch = this.pickNames.map((n) => swn.includes(n.toLowerCase().trim()));
      // value order per option (same order as the main pickers / product options)
      this.pickValues = this.pickNames.map((_, k) => {
        const seen = []; this.variants.forEach((v) => { if (!seen.includes(v.options[k])) seen.push(v.options[k]); });
        const fs = this.querySelectorAll('fieldset[data-cz-option]')[k];
        if (fs) { const order = [...fs.querySelectorAll('[data-cz-option-input]')].map((i) => i.value); seen.sort((a, b) => order.indexOf(a) - order.indexOf(b)); }
        return seen;
      });
      this.rows = [];
      this.updatePicks();
    }
    pickQty() { const r = this.querySelector('[data-cz-qty-radio]:checked'); return r ? parseInt(r.value, 10) || 1 : 1; }
    findVariant(opts) { return this.variants.find((v) => v.options.every((o, i) => o === opts[i])); }
    resolveRow(row) {
      const v = this.findVariant(row.opts);
      if (v && v.available) return v;
      // nearest available: keep as many leading options as possible, then the closest value index for the rest
      let best = null, bestScore = Infinity;
      this.variants.forEach((c) => {
        if (!c.available) return;
        let score = 0;
        c.options.forEach((o, i) => {
          if (o === row.opts[i]) return;
          const d = Math.abs(this.pickValues[i].indexOf(o) - this.pickValues[i].indexOf(row.opts[i]));
          score += (i === 0 ? 1000 : 1) * (d || 1) + (this.pickNames.length - i) * 0.01;
        });
        if (score < bestScore) { bestScore = score; best = c; }
      });
      if (best) {
        const changed = best.options.map((o, i) => (o !== row.opts[i] ? o : null)).filter(Boolean);
        row.note = (S.pickSwitched || '[old] isn’t available in [ctx], switched to [new].')
          .replace('[old]', row.opts.filter((o, i) => o !== best.options[i]).join(' / '))
          .replace('[ctx]', best.options.filter((o, i) => o === row.opts[i]).join(' / ') || '—')
          .replace('[new]', changed.join(' / '));
        row.opts = best.options.slice();
      }
      return best;
    }
    onPickChange(sel) {
      const row = this.rows[parseInt(sel.dataset.row, 10)];
      if (!row) return;
      row.opts[parseInt(sel.dataset.opt, 10)] = sel.value; row.touched = true; row.note = '';
      this.updatePicks();
    }
    updatePicks() {
      if (!this.picks) return;
      const q = this.pickQty();
      const col = q; this.picks.style.setProperty('--cz-pick-col', col);
      if (q < 2) { this.picks.hidden = true; this.render(this.currentVariant()); return; }
      const main = this.selectedOptions();
      for (let i = 0; i < q; i++) {
        if (!this.rows[i]) this.rows[i] = { opts: main.slice(), touched: false, note: '' };
        if (!this.rows[i].touched && main.every((m) => m != null)) this.rows[i].opts = main.slice();
      }
      const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      let html = '';
      for (let i = 0; i < q; i++) {
        const row = this.rows[i]; this.resolveRow(row);
        html += `<div class="cz-pick"><span class="cz-pick__n">#${i + 1}</span><div class="cz-pick__fields">`;
        this.pickNames.forEach((name, k) => {
          const opts = this.pickValues[k].map((val) => {
            const probe = row.opts.slice(); probe[k] = val;
            let ok, why = '';
            if (k === 0) { ok = this.variants.some((v) => v.available && v.options[0] === val); if (!ok) why = S.soldOut || 'Sold out'; }
            else {
              const v = this.variants.find((c) => c.options.every((o, j) => (j === k ? o === val : j < k ? o === row.opts[j] : true)) && c.available);
              ok = !!v;
              if (!ok) why = this.variants.some((c) => c.options.every((o, j) => (j === k ? o === val : j < k ? o === row.opts[j] : true))) ? (S.soldOut || 'Sold out') : (S.unavailable || 'Unavailable');
            }
            return `<option value="${esc(val)}"${val === row.opts[k] ? ' selected' : ''}${ok ? '' : ' disabled'}>${esc(val)}${ok ? '' : ' (' + esc(why) + ')'}</option>`;
          }).join('');
          const sw = this.pickIsSwatch[k] ? ((this.pickSw[name] || {})[row.opts[k]] || '') : null;
          html += `<label class="cz-pick__field${sw !== null ? ' cz-pick__field--swatch' : ''}"><span class="cz-visually-hidden">#${i + 1} ${esc(name)}</span>` +
            (sw !== null ? `<span class="cz-pick__dot${sw ? '' : ' cz-pick__dot--empty'}" style="${esc(sw)}" aria-hidden="true"></span>` : '') +
            `<select data-cz-pick data-row="${i}" data-opt="${k}">${opts}</select></label>`;
        });
        html += `</div>${row.note ? `<p class="cz-pick__note" role="status">${esc(row.note)}</p>` : ''}</div>`;
      }
      this.picks.querySelector('[data-cz-picks-rows]').innerHTML = html;
      this.picks.hidden = false;
      this.render(this.currentVariant());
    }
    pickItems() {
      const q = this.pickQty();
      if (!this.picks || q < 2) return null;
      const merged = new Map();
      for (let i = 0; i < q; i++) {
        const v = this.findVariant(this.rows[i].opts);
        if (!v || !v.available) return false;
        merged.set(v.id, (merged.get(v.id) || 0) + 1);
      }
      return [...merged].map(([id, quantity]) => ({ id, quantity }));
    }
    selectedOptions() {
      return [...this.querySelectorAll('fieldset[data-cz-option]')].map((fs) => {
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    currentVariant() {
      const sel = this.selectedOptions();
      return this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    }
    onOptionChange() {
      this.querySelectorAll('fieldset[data-cz-option]').forEach((fs) => {
        const c = fs.querySelector('input:checked');
        const lbl = fs.querySelector('[data-cz-selected-label]');
        if (c && lbl) lbl.textContent = c.value;
      });
      const v = this.currentVariant();
      this.updateAvailability();
      this.render(v);
      if (v) {
        this.idInput.value = v.id;
        if (this.dataset.updateUrl === 'true') {
          const u = new URL(location.href); u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
        if (v.featured_media) {
          document.querySelectorAll(`cz-gallery[data-section-id="${this.sectionId}"]`).forEach((g) => g.goToMedia(v.featured_media.id));
        }
      }
    }
    updateAvailability() {
      // mark values that are not available given the other selected options
      const sel = this.selectedOptions();
      this.querySelectorAll('fieldset[data-cz-option]').forEach((fs, idx) => {
        fs.querySelectorAll('[data-cz-option-input]').forEach((input) => {
          const ok = this.variants.some((v) => v.available && v.options[idx] === input.value && v.options.every((o, i) => i === idx || sel[i] == null || o === sel[i]));
          input.classList.toggle('cz-is-unavailable', !ok);
        });
      });
    }
    render(v) {
      const now = this.querySelector('[data-cz-price-now]');
      const was = this.querySelector('[data-cz-price-was]');
      const badge = this.querySelector('[data-cz-price-badge]');
      const label = this.querySelector('[data-cz-submit-label]');
      if (!v) {
        this.submit.disabled = true; label.textContent = S.unavailable || 'Unavailable';
        this.syncSticky(null); return;
      }
      if (now) now.textContent = formatMoney(v.price);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (was) { was.hidden = !onSale; if (onSale) was.textContent = formatMoney(v.compare_at_price); }
      if (badge) { badge.hidden = !onSale; const s = badge.querySelector('[data-cz-save]'); if (s && onSale) s.textContent = formatMoney(v.compare_at_price - v.price); }
      // offer tiles: genuine totals for the selected variant (price x qty), minus the displayed bundle %
      this.querySelectorAll('[data-cz-qty-radio]').forEach((r) => {
        const q = parseInt(r.value, 10) || 1, pct = parseFloat(r.dataset.pct) || 0;
        let full = v.price * q, disc = Math.floor(full * pct / 100);
        if (this.picks && r.checked && q > 1 && this.rows && this.rows.length >= q) {
          // selected tile with per-item picks: genuine sum of the chosen variants
          // match Shopify: the % is taken per cart line (same variants merged) and rounded down to the cent
          full = 0; const lines = {};
          for (let i = 0; i < q; i++) { const pv = this.findVariant(this.rows[i].opts) || v; full += pv.price; lines[pv.id] = (lines[pv.id] || 0) + pv.price; }
          disc = Object.values(lines).reduce((s, lt) => s + Math.floor(lt * pct / 100), 0);
        }
        const now = full - disc;
        const set = (sel, val) => { const el = this.querySelector(`[${sel}="${q}"]`); if (el) el.lastChild.textContent = formatMoney(val); };
        set('data-cz-offer-now', now); set('data-cz-offer-was', full); set('data-cz-offer-each', Math.round(now / q));
      });
      this.submit.disabled = !v.available;
      label.textContent = v.available ? S.addToCart : S.soldOut;
      this.syncSticky(v);
    }
    syncSticky(v = this.currentVariant()) {
      const bar = document.querySelector(`[data-cz-sticky="${this.form && this.form.id}"]`);
      if (!bar) return;
      const btn = bar.querySelector('[data-cz-sticky-btn]');
      const vt = bar.querySelector('[data-cz-sticky-variant]');
      const pr = bar.querySelector('[data-cz-sticky-price]');
      if (!v) { btn.disabled = true; btn.textContent = S.unavailable; return; }
      if (vt && this.variants.length > 1) vt.textContent = v.title + ' · ';
      if (pr) pr.textContent = formatMoney(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? S.addToCart : S.soldOut;
    }
    async onSubmit(e) {
      e.preventDefault();
      if (this.submit.disabled) return;
      const err = this.querySelector('[data-cz-error]');
      const label = this.querySelector('[data-cz-submit-label]');
      err.hidden = true;
      this.submit.setAttribute('aria-busy', 'true'); this.submit.disabled = true;
      const prev = label.textContent; label.textContent = S.adding || '…';
      const fd = new FormData(this.form);
      const addon = fd.get('cz_addon');
      fd.delete('cz_addon');
      let body, headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      const picked = this.pickItems();
      // cap: max 2 duvet sets per order
      if ((this.dataset.productUrl || '').split('?')[0].endsWith('/products/' + CAP_HANDLE)) {
        const want = picked ? picked.reduce((s, i) => s + i.quantity, 0) : Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
        let have = 0; try { have = capCount(await capCart()); } catch (_) {}
        if (have + want > CAP_MAX) {
          err.textContent = CAP_MSG + (have ? ` (${have} already in your cart)` : ''); err.hidden = false;
          this.submit.removeAttribute('aria-busy'); this.submit.disabled = false; label.textContent = prev;
          capHit = true; if (have) openDrawer('cz-cart'); enforceCap();
          return;
        }
      }
      if (picked === false) {
        err.textContent = S.unavailable || 'Unavailable'; err.hidden = false;
        this.submit.removeAttribute('aria-busy'); this.submit.disabled = false; label.textContent = prev; return;
      }
      if (picked) {
        // bundle tile 2/3: every chosen variant in ONE request (same variants merged into quantity)
        const items = picked.slice();
        if (addon) items.push({ id: Number(addon), quantity: 1 });
        body = JSON.stringify({ items, sections: cartSections(), sections_url: location.pathname });
        headers['Content-Type'] = 'application/json';
      } else if (addon) {
        // main item + optional "complete the bed" add-on in one request
        const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }, { id: Number(addon), quantity: 1 }];
        body = JSON.stringify({ items, sections: cartSections(), sections_url: location.pathname });
        headers['Content-Type'] = 'application/json';
      } else {
        fd.append('sections', cartSections().join(','));
        fd.append('sections_url', location.pathname);
        body = fd;
      }
      try {
        const res = await fetch(root + 'cart/add.js', { method: 'POST', headers, body });
        const data = await res.json();
        if (!res.ok || data.status) {
          err.textContent = data.description || data.message || S.error; err.hidden = false;
        } else {
          if (data.sections) renderSections(data.sections);
          if (!document.querySelector('[data-cz-cart-page]') && !openDrawer('cz-cart')) location.href = root + 'cart';
        }
      } catch (_) {
        err.textContent = S.error; err.hidden = false;
      } finally {
        this.submit.removeAttribute('aria-busy'); this.submit.disabled = false; label.textContent = prev;
      }
    }
  }
  if (!customElements.get('cz-product-form')) customElements.define('cz-product-form', CzProductForm);
  { const ci = document.querySelector('[data-cz-cart-inner]'); if ((ci && ci.dataset.count !== '0') || document.querySelector('[data-cz-cart-page]')) enforceCap(); }

  /* ---------- upsell (one-click add) ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-cz-upsell-select]');
    if (!sel) return;
    const box = sel.closest('[data-cz-upsell]');
    box.querySelector('[data-cz-upsell-add]').dataset.variantId = sel.value;
    const opt = sel.selectedOptions[0], pr = box.querySelector('[data-cz-upsell-price]');
    if (pr && opt && opt.dataset.price) pr.textContent = opt.dataset.price;
  });
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cz-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-cz-upsell]');
    const err = box && box.querySelector('[data-cz-upsell-err]');
    if (err) err.hidden = true;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }], sections: cartSections(), sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        if (err) { err.textContent = data.description || data.message || S.error; err.hidden = false; }
      } else {
        if (data.sections) renderSections(data.sections);
        if (!document.querySelector('[data-cz-cart-page]') && !document.querySelector('#cz-cart:not([hidden])') && !openDrawer('cz-cart')) location.href = root + 'cart';
      }
    } catch (_) {
      if (err) { err.textContent = S.error; err.hidden = false; }
    } finally {
      if (btn.isConnected) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });

  /* ---------- gallery ---------- */
  class CzGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cz-track]');
      this.slides = [...this.querySelectorAll('.cz-gallery__slide')];
      this.dots = [...this.querySelectorAll('.cz-gallery__dot')];
      this.counter = this.querySelector('[data-cz-count]');
      this.thumbs = [...this.querySelectorAll('[data-cz-thumb]')];
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.czThumb, 10))));
      let raf;
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth))); }, { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { this.goTo(this.index + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { this.goTo(this.index - 1); e.preventDefault(); }
      });
      this.index = 0;
    }
    setActive(i) {
      this.index = i;
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      if (this.counter) this.counter.textContent = String(Math.max(0, Math.min(this.slides.length - 1, i)) + 1);
      const at = this.thumbs[i];
      if (at && at.parentElement && at.parentElement.scrollWidth > at.parentElement.clientWidth) at.parentElement.scrollTo({ left: at.offsetLeft - at.parentElement.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
    }
    goTo(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.setActive(i);
    }
    goToMedia(id) {
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i >= 0) this.goTo(i);
    }
  }
  if (!customElements.get('cz-gallery')) customElements.define('cz-gallery', CzGallery);

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    document.querySelectorAll('[data-cz-sticky]').forEach((bar) => {
      const form = document.getElementById(bar.dataset.czSticky);
      const btn = form && form.querySelector('[data-cz-submit]');
      if (!btn || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.querySelector('[data-cz-sticky-btn]').tabIndex = show ? 0 : -1;
      });
      io.observe(btn);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
  document.addEventListener('shopify:section:load', initSticky);
})();

/* v28: move blocks flagged 'Show under gallery on desktop' into the left column on desktop (rendered once; moved back on mobile) */
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  const run = () => document.querySelectorAll('[data-cz-product-section]').forEach((sec) => {
    const tgt = sec.querySelector('[data-cz-below-target]');
    if (!tgt) return;
    sec.querySelectorAll('[data-cz-below]').forEach((el) => {
      if (!el.czHome) { el.czHome = document.createComment('cz-below'); el.before(el.czHome); }
      if (mq.matches) { if (el.parentElement !== tgt) tgt.append(el); }
      else if (el.czHome.parentNode && el.czHome.nextSibling !== el) el.czHome.after(el);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (mq.addEventListener) mq.addEventListener('change', run); else mq.addListener(run);
  document.addEventListener('shopify:section:load', run);
})();
